module.exports = __webpack_public_path__ + "static/media/trust-account.ce911e62.svg";